const USUARIOS_LIBERADOS = new Set([1, 2, 30, 5619]);
const USUARIOS_POSICAO_ESTOQUES_RESTRITA = new Set([5619]);

export const getUsuarioId = (usuario) => {
  const valor = usuario?.usuario_id ?? usuario?.USUARIO_ID ?? usuario?.id ?? usuario?.ID;
  const id = Number(valor);
  return Number.isFinite(id) ? id : null;
};

export const usuarioPodeAcessarConsulta = (usuario) => {
  const id = getUsuarioId(usuario);
  return id !== null && USUARIOS_LIBERADOS.has(id);
};


export const usuarioTemPosicaoEstoquesRestrita = (usuario) => {
  const id = getUsuarioId(usuario);
  return id !== null && USUARIOS_POSICAO_ESTOQUES_RESTRITA.has(id);
};
